import c from "./ghl-ui.es1303.js";
var i = 500;
function m(a) {
  var e = c(a, function(t) {
    return r.size === i && r.clear(), t;
  }), r = e.cache;
  return e;
}
export {
  m as default
};
